/* The two drill-down addresses, built from the route patterns rather than assembled from segments.
 *
 * **`SCREEN_PATHS.reconciliationRun.replace(…)` rather than a template over the parent path**, which
 * is the spelling most of this app uses. The difference matters here because this feature's second
 * route has a literal segment in the middle (`/reconciliation/:definitionId/runs/:runId`), so a
 * template would spell `/runs/` a second time — and `shared/routes.ts` says in its own words why that
 * is the wrong direction: "Two copies of a route is how the collision this file exists to prevent
 * gets re-created". Substituting into the pattern means the pattern stays the only place the shape is
 * written down, and moving the segment is one edit.
 *
 * **A module of their own rather than exports beside the components**, because `react-refresh` warns
 * on a file that exports both a component and a function — correctly: an edit to a path helper would
 * force a full reload of the screen rather than a hot swap, and both screens import each other's
 * builder.
 */

import { SCREEN_PATHS } from '@/shared/routes';

/** One definition's runs. */
export function definitionPath(definitionId: string): string {
  return SCREEN_PATHS.reconciliationDefinition.replace(
    ':definitionId',
    encodeURIComponent(definitionId),
  );
}

/** One run's masked breaks. */
export function breaksPath(definitionId: string, runId: string): string {
  return SCREEN_PATHS.reconciliationRun
    .replace(':definitionId', encodeURIComponent(definitionId))
    .replace(':runId', encodeURIComponent(runId));
}
